import React from "react";
import { Container } from "react-bootstrap";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "./termsofuse.css";

const TermsOfUse = () => {
  return (
    <div className="terms_section">
      <div className="terms">
        <Header />
        <Container>
          <p>
            The mobile application Splendid App on Android and iOS operating systems and webstore
            links (collectively, “Platforms”), are managed and operated by M/s. Splendid App Private
            Limited (“Splendid App”, “we”, “us” or “our”). Any natural or legal person who accesses
            and/or uses the Platforms in any manner (“you” or “your”) or uses any current or future
            service or functionality or offer made available on the Platforms (“Service”) will be
            subject to these terms and conditions for use of the Platforms (“Terms”), as updated
            from time to time. Your access to Services, other platforms or utilisation of Services,
            offers or promotions in relation to the Services, as may be provided by us or our
            affiliates, may be governed by other terms and conditions, policies or guidelines
            (“Additional Terms”) along with these Terms. If these Terms are inconsistent with such
            Additional Terms, the Additional Terms will take precedence to the extent of such
            inconsistency with respect to the applicable Service or utilisation of the Platform.
          </p>
          <p>
            These Terms constitute an electronic record within the meaning of the Information
            Technology Act, 2002. This electronic record is generated by a computer system and does
            not require any physical or digital signatures. Please read these Terms carefully before
            using or accessing the Platforms or availing any Service. By using the Platforms or
            availing any Service, you signify your agreement to be bound by these Terms.
          </p>
          <p>
            For the purposes of these Terms, “Services” shall mean the Platform and the various
            services it provides; We and you are hereinafter individually referred to as “Party” and
            collectively as “Parties”. Please carefully read all the parts to understand the
            conditions applicable for usage of the Platforms.
          </p>
          <p>
            <b>PART A – TERMS AND CONDITIONS FOR USAGE OF THE PLATFORMS</b>
          </p>
          <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
            <li>
              <b>1. GENERAL:</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>1.1.</span> The terms and conditions for usage of the Platforms as set out
                  herein (“Terms of Use”) specifically govern your access and use of the Platforms.
                  Our Services allow you to become an Influencer/creator on the Platform and
                  upload/link content which can be purchased directly by the public and/or you can
                  shop the looks you like from thousands of Influencers (individuals and entities
                  with websites, blogs, social media presence, agents or agencies, digital
                  publishers and other content platforms). As a registered user of the App, you can
                  also find, follow, and shop influencer content directly in the App. We may also
                  provide emailers of content and Influencers that may interest you. Our Services
                  create technological and commercial relationships between third-party retailers,
                  advertisers and other businesses (“Merchants”), individuals and entities with
                  websites, blogs, social media presence, agents or agencies, digital publishers and
                  other content platforms (“Influencers”) and consumers. Our Services create a free,
                  fun and convenient shopping experience while facilitating sales and marketing of
                  Merchant products and services (collectively, “Products”) and the payment of
                  commissions to Influencers.
                </li>
                <li>
                  <span>1.2.</span> Please note that we may from time to time, modify the Terms of
                  Use that govern your use of the Platforms either as an Influencer or as a general
                  user. Every time you wish to use our Platforms, please check these Terms of Use to
                  ensure that you understand the terms and conditions that apply at that time.
                  Further, please note that we reserve the right to either change the format and the
                  content of the Platforms or suspend the operation of the Platforms for support or
                  maintenance work, in order to update the content or for any other reason, at any
                  time.
                </li>
                <li>
                  <span>1.3.</span> The accessing, browsing, or otherwise using the Platforms
                  indicates your agreement to these Terms of Use, the Privacy Policy and any other
                  policies or guidelines that may be applicable to the Platforms at the time of your
                  access and usage of the Platforms and which may be updated from time to time
                  (collectively, the “Agreement”).
                </li>
                <li>
                  <span>1.4.</span> We authorise you to view and access the Platforms solely for
                  creating and posting/linking content which has been created by you showcasing your
                  style and the Products which can be bought from Merchants, identifying Products,
                  carrying out purchases of Products and processing returns and refunds, in
                  accordance with the Return and Refund Policy. We therefore grant you a limited,
                  revocable permission to access and use the Services.
                </li>
                <li>
                  <span>1.5.</span> By accepting this Agreement, you affirm that you are 18
                  (Eighteen) years of age or above and are fully competent to enter into this
                  Agreement, and to abide by and comply with this Agreement. If a user is below 18
                  (Eighteen) years of age, it is assumed that he/she is using/browsing the concerned
                  Platform under the supervision of his/her parent or legal guardian and that such
                  user’s parent or legal guardian has read and agrees to the terms of this
                  Agreement, including the terms of purchase of Products on behalf of the minor
                  user. In the event we are made aware that a user is under the age of 18 and is
                  using/browsing the Platform without the supervision of his/her parent or legal
                  guardian, we reserve the right to deactivate such user’s account without further
                  notice. Further, if you are using the Services on behalf of a company or
                  organisation, you represent that you have the authority to act on behalf of that
                  entity, and that such entity accepts this Agreement.
                </li>
              </ol>
            </li>
            <li>
              <b>2. REGISTRATION OF YOUR ACCOUNT</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>2.1.</span> You agree to provide certain information to set up your account.
                  As part of the registration process, you will select a username and password and
                  may provide certain personal information. You hereby consent to our access to and
                  collection of such personal information about you. By registering for the
                  Services, you hereby authorize us to send you emails and other communications. You
                  agree to protect your password and not share your account with others. You are
                  solely responsible for maintaining the confidentiality of your username and
                  password. You may not authorize others to use your account, and you may not share,
                  assign or otherwise transfer your account or login information to any other person
                  or entity. You are responsible for any and all activities that are conducted
                  through your account. Splendid App shall be entitled to assume that a user
                  presenting your username and password is, in fact, you. You agree to notify us
                  immediately of any unauthorized use of your account. We shall have the right at
                  any time to change, modify or amend your username and password. You agree to
                  provide correct information and keep it updated. You agree to only use our
                  Services for personal reasons and not, for example, to compete with us. You
                  represent and warrant that the information you provide to us is accurate, true,
                  not confidential, and not in violation of any contractual obligations or other
                  third-party rights. You agree that it is your responsibility to keep your
                  information accurate and updated. You represent and warrant that you are not a
                  competitor of Splendid App and are not using the Services in competition with
                  Splendid App. You further represent and warrant that you are using the Services
                  solely for personal reasons and that you are not an attorney or an agent of an
                  attorney conducting an investigation to a potential claim related to the Services,
                  any materials available through the Services, or Splendid App.
                </li>
                <li>
                  <span>2.2.</span> You will:
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      (a). immediately inform us of any unauthorized use of the account or any other
                      security breach; and
                    </li>
                    <li>
                      (b). ensure that you log out of your account at the end of each session. We,
                      our employees, agents, directors and officers will not be liable for any loss
                      or direct or indirect damage arising from your failure to comply with these
                      Terms of Use. You may be held liable for any losses incurred to us or any
                      other user due to unauthorized use of their account by you. We reserve the
                      right to refuse access to the Platform(s), terminate accounts, remove or edit
                      content at any time without notice to you.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <b>3. COMMUNICATION AND UNSUBSCRIPTION</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>3.1.</span> By accepting the Terms of Use, you also accept to receive news,
                  updates, offers/ campaign related SMS, to the mobile phone number provided by you.
                  By accessing and using the Platforms and/or verifying your contact number with us,
                  you explicitly consent to receive such communications (through call, SMS, email or
                  other digital and electronic means) from us and/or our authorized representatives
                  regarding any new services or offerings, even if your contact number is registered
                  under the DND/NCPR list under the Telecom Commercial Communications Customer
                  Preference Regulations, 2018.
                </li>
                <li>
                  <span>3.2.</span> By registering on the App or any Splendid App platform, You
                  grant Splendid App, authorization to share marketing related communications via
                  WhatsApp, email, etc.
                </li>
                <li>
                  <span>3.3.</span> You also grant Splendid App the right to utilize and
                  redistribute your content for promotional purposes, including sharing it via
                  WhatsApp and other marketing channels to enhance post visibility and drive
                  traffic.
                </li>
                <li>
                  <span>3.4.</span> You can unsubscribe/ opt-out from receiving marketing/
                  promotional communications, newsletters and other notifications from us at any
                  time by following the instructions set out in such communications.
                </li>
              </ol>
            </li>
            <li>
              <b>4. ACCESS TO IMAGES/CONTENT</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>4.1.</span> By accepting the Terms, you provide explicit consent to us, to
                  have access to your camera and gallery applications installed in your phone or
                  computer, through which you are using the Platforms, for the purpose of enabling
                  us to provide Services.
                </li>
                <li>
                  <span>4.2.</span> You acknowledge and agree that in addition to the restrictions
                  set out in paragraph 11 (User Warranties and Restrictions), you will ensure that
                  any image/content uploaded by you:
                  <ul style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      (i). does not belong to another person, in relation to which you do not have
                      any right; or
                    </li>
                    <li>
                      (ii). such image/content is not defamatory, obscene, pornographic,
                      paedophilic, invasive of another’s privacy, including bodily privacy,
                      insulting or harassing on the basis of gender, libellous, racially or
                      ethically objectionable; or
                    </li>
                    <li>(iii). is not harmful to child;</li>
                    <li>(iv). should not infringe any copyright or other proprietary rights;</li>
                    <li>(v). does not impersonate another person; or</li>
                    <li>
                      (vi). does not contain software virus or any other computer code, file or
                      program designed to interrupt, destroy or limit the functionality of any
                      computer resource; or
                    </li>
                    <li>
                      (vii). should not contain indecent representation of women in any form; or
                    </li>
                    <li>
                      (viii). violates any law for the time being in force, including but not
                      limited to Information Technology Act, 2000, Indecent Representation of Women
                      (Prohibition) Act, 1986 and Indian Penal Code 1860, and the rules made
                      thereunder (as applicable).
                    </li>
                  </ul>
                </li>
                <li>
                  <span>4.3.</span> When you upload images/content that are covered by third party
                  intellectual property rights, you grant or in case of a third party, ensure that
                  they are granted by you (whether by yourself or on behalf of the third party), a
                  non-exclusive, royalty-free, transferable, sub- licensable, worldwide licence to
                  use, distribute, copy, or display, translate and create derivative works of the
                  images/content that you upload, solely in connection with the Services.
                </li>
                <li>
                  <span>4.4.</span> You acknowledge and accept that for the purpose of providing
                  Services, the images/content uploaded by you may be accessed, used or processed by
                  a third party, and that we have no liability, obligation or responsibility of any
                  nature towards you or such third party and the contract under such instances
                  remains between you and such third party.
                </li>
                <li>
                  <span>4.5.</span> In the event of breach of any of the obligations mentioned in
                  this paragraph 4 (Access to Images/Content), you accept that we will not be liable
                  to you or any third-party in relation to any claims, losses, liabilities, damages,
                  and/or costs (including any attorney fees and costs) which may arise from breach
                  of the aforesaid obligations. You further agree that you will be liable to
                  indemnify us in accordance with paragraph 12 (Indemnification and Limitation of
                  Liability) of the Terms.
                </li>
              </ol>
            </li>
            <li>
              <b>5. DISCLAIMER OF WARRANTIES, INACCURACIES OR ERRORS</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>5.1.</span> We will try to ensure that all information and recommendations,
                  whether in relation to the Products, Services, offerings or otherwise (hereinafter
                  “Information”) provided as part of the Platforms is correct at the time of
                  inclusion on the concerned Platform. We do not guarantee the accuracy of the
                  Information. We make no representations or warranties as to the completeness or
                  accuracy of Information.
                </li>
                <li>
                  <span>5.2.</span> You agree that Information is being supplied to you on the
                  condition that you will make your own determination as to the suitability of such
                  information for your purpose prior to use or in connection with the making of any
                  decision. No Information on the Platforms shall constitute an invitation to invest
                  in us or any affiliates, Influencers or Merchants. Any use of the Platforms or the
                  Information is at your own risk. Neither we, our affiliates, nor their officers,
                  employees nor agents shall be liable for any loss, damage or expense arising out
                  of any access to, use of, or reliance upon, this website, the Information, or any
                  third-party website linked to the Platforms. We are not responsible for the
                  content of any third-party sites and do not make any representations regarding the
                  content or accuracy of material on such sites. If you decide to access links of
                  any third- party platforms, you are doing so entirely at your own risk and
                  expense.
                </li>
                <li>
                  <span>5.3.</span> As a means to assist the users in identifying the Products of
                  their choice, we provide visual representations on the Platforms including
                  graphics, illustrations, photographs, images, content, videos, charts,
                  screenshots, infographics and other visual aids. While reasonable efforts are made
                  to provide accurate visual representation, we disclaim any guarantee or warranty
                  of exactness of such visual representation or description of the Product, with the
                  actual Product ultimately delivered to users. The appearance of the Product when
                  delivered may vary for various reasons.
                </li>
                <li>
                  <span>5.4.</span> Nothing contained herein is to be construed as a recommendation
                  to use any Product, process, equipment or formulation, in conflict with any
                  patent, or otherwise and we make no representation or warranty, express or implied
                  that, the use thereof will not infringe any patent, or otherwise.
                </li>
                <li>
                  <span>5.5.</span> We do not covenant or provide any representations and
                  warranties:
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      <span>5.1.1.</span> in respect of quality, suitability, accuracy, reliability,
                      performance, safety, merchantability, fitness for a particular
                      purpose/consumption or the content (including Product or pricing information
                      and/or specifications) on the Platforms;
                    </li>
                    <li>
                      <span>5.1.2</span> that the Services will be made available at all times; and
                    </li>
                    <li>
                      <span>5.1.3</span> that the operation of the Platforms, including the
                      functions contained in any content, information and materials on any Platform
                      or any third-party sites or services linked to the Platforms will be
                      uninterrupted, or that the defects will be rectified, or that the Platforms or
                      the servers that make such content, information and materials available are
                      free of viruses or other harmful components.
                    </li>
                  </ol>
                </li>
                <li>
                  <span>5.6.</span> THE PLATFORMS AND THE SERVICES ARE PROVIDED TO YOU ON AN “AS IS”
                  AND “WHERE-IS” BASIS, WITHOUT ANY REPRESENTATIONS OR WARRANTIES. WE, FOR OURSELF
                  AND ANY THIRD-PARTY PROVIDING MATERIALS, SERVICES, OR CONTENT TO THIS WEBSITE,
                  MAKE NO REPRESENTATIONS OR WARRANTIES, EITHER EXPRESS, IMPLIED, STATUTORY OR
                  OTHERWISE OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT
                  OF THIRD-PARTY RIGHTS, WITH RESPECT TO THE PLATFORMS, THE INFORMATION OR ANY
                  PRODUCTS OR SERVICES TO WHICH THE INFORMATION REFERS. WE WILL NOT BE LIABLE TO YOU
                  OR ANY THIRD PARTY FOR ANY DAMAGES OF ANY KIND, INCLUDING BUT NOT LIMITED TO,
                  DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, ARISING FROM OR
                  CONNECTED WITH THE SITE, INCLUDING BUT NOT LIMITED TO, YOUR USE OF THIS SITE OR
                  YOUR INABILITY TO USE THE SITE, EVEN IF WE HAVE PREVIOUSLY BEEN ADVISED OF THE
                  POSSIBILITY OF SUCH DAMAGES.
                </li>
                <li>
                  Disclaimer - To the extent permitted by applicable law, We, our officers, agents,
                  employees and directors, disclaim any liability against any loss, damage,
                  expenses, liabilities, claim, injury caused due to the failure of performance,
                  omission, defect of products, or deletion, interruption, error, delay, virus,
                  communication, unauthorised access, theft, destruction, alteration or use of
                  records on the Platforms.
                </li>
              </ol>
            </li>
            <li>
              <b>6. COMMISSION AND CASH PAY-OUT</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>6.1.</span>
                  As an additional Service, you have the option to apply for membership through the
                  Splendid App. To express your intent to join, you can communicate with our team
                  at &nbsp;
                  <a href="mailto:hello@splendid.app">hello@splendid.app</a>
                  We retain the sole discretion to approve or deny any application., without the
                  obligation to provide reasons for such decisions. Our determination in this regard
                  shall be final and binding. Nothing in these Terms and Conditions should be
                  construed as an offer to join the Platform.
                </li>
                <li>
                  <span>6.2.</span>
                  Once your membership has been approved, you will be allowed to publish and
                  disseminate your content to other users of the Mobile App. There will be
                  additional terms and conditions which will be applicable to you. Only on accepting
                  those would your membership be approved. Other users will be able to discover your
                  content and make purchases of Products forming a part of your content. In the
                  event that any user makes a purchase from the Splendid App App through your
                  content (forming a part of your content), you will be entitled to receive a %
                  commission on the net sales amount (calculated after returns, taxes, commissions
                  and any other adjustments), contingent upon the actual sales volume
                  (“Commissions”). The commission rates for each participating brand/ Merchant will
                  be published on the Splendid App and its extensions periodically and communicated
                  to the Influencer in writing or via electronic means. The Influencer can also
                  check the commission rates for the participating brands on –{" "}
                  {/* <a href="https://app.splendid.app/brands" target="_blank"> */}
                  <b>app.splendid.app/brands</b>
                  {/* </a> */}. The determination of net sales amount and applicable commission
                  percentage shall be at our discretion. We reserve the right to modify commission
                  rates and conditions at our sole discretion, with any such changes communicated
                  members in a timely manner. The commission shall be subject to applicable taxes
                  and deductions as required by law.
                </li>
                <li>
                  <span>6.3.</span> All Commissions (if any) will be calculated based on the net
                  sales generated through your shop each calendar month. "Net sales" are defined as
                  the total sales amount less returns, and/or cancellations. A detailed breakdown of
                  the Commissions will be available on your Splendid App account dashboard
                  periodically. All Commissions are processed only after the return/refund period
                  for products ends with the Partners, confirming final sales, and Partner
                  confirmations. We may withhold or reverse Commission payments in case of returns,
                  refunds, or other factors affecting sale finality, all such actions will be
                  communicated to you via email as provided at the time of registration.
                </li>
                <li>
                  {" "}
                  <span>6.4.</span>
                  The minimum payout threshold for Commission is set at <b>Rs. 500</b> (Rupees Five
                  Hundred Only) i.e., you must have this minimum amount in your Splendid App wallet
                  for you to effect any withdrawal.{" "}
                  <b>
                    All Commissions earned until the 20th of each month will be eligible for
                    withdrawal on 15 th of the succeeding month
                  </b>{" "}
                  (“Withdrawal Date”) subject to the condition that the Influencer generates and
                  provides the invoice to Splendid App before such withdrawal date. In the event the
                  Commissions are not withdrawn on the Withdrawal Date of a particular month or the
                  Influencer does not generate the invoice within the specified period as mentioned,
                  they will then be eligible to be withdrawn in the subsequent month's Withdrawal
                  Date. It is clarified that there will be no withdrawals permitted until the next
                  withdrawal date. To withdraw the Commissions, you need to click on the withdraw
                  button on your Splendid App account dashboard for automatic processing of the
                  withdrawals (maximum <b>Rs. 1,00,000/- (Rupees One Lakh only)</b>). All
                  Commissions beyond this maximum limit will have to go through manual withdrawals.
                  For manual withdrawals, you must send us an email on{" "}
                  <a href="mailto:hello@splendid.app">hello@splendid.app</a> and submit a withdrawal
                  request, a member from our customer service team will reach out to you and assist
                  you in the process
                </li>
                <li>
                  <span>6.5.</span> All Commissions will be credited to the bank account specified
                  by you in your Splendid App account at the time of registration and/or while
                  withdrawing the commission. We disclaim any responsibility for issues arising from
                  inaccurate account information provided by you with respect to the Commission
                  payouts.
                </li>
                <li>
                  <span>6.6.</span> All non-withdrawn Commissions will continue to accrue and shall
                  not expire until you terminate your account with us. Any outstanding amounts above
                  the minimum threshold will be finally paid out when you request to cancel or
                  revoke your participation in the platform.
                </li>
                <li>
                  <span>6.7.</span> All non-withdrawn Commissions will continue to accrue and shall
                  not expire until you terminate your account with us. Any outstanding amounts above
                  the minimum threshold will be finally paid out when you request to cancel or
                  revoke your participation in the Program.
                </li>
                <li>
                  <span>6.8.</span> All payments made to the Influencer towards the commission for
                  the net sales generated for our partner brands via various authorized platforms
                  shall be subject to Tax Deducted at Source (TDS) as per the prevailing tax laws in
                  India. The Company shall deduct the applicable TDS amount at the time of payment
                  and deposit the same with the relevant tax authorities within the stipulated
                  timeline. The Company agrees to provide the Influencer with the necessary TDS
                  certificate for the deducted amount, facilitating the Influencer's tax compliance.
                </li>
                <li>
                  <span>6.9.</span> In addition to the above commission, any incentive, bonus, or
                  any other monetary or non-monetary benefit provided to the Influencer over and
                  above the agreed commission shall also be subject to Tax Deducted at Source (TDS)
                  as per applicable laws.
                </li>
              </ol>
            </li>
            <li>
              <b>7. PLAGIARISM</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>7.1.</span> Splendid App values originality and respects the creative rights
                  of all content shared on its platform. Any act of plagiarism or infringement of
                  intellectual property rights (including copyright) and/or duplicating any content
                  is strictly prohibited.
                </li>
                <li>
                  <span>7.2.</span> Plagiarism includes but is not limited to:
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      <span>7.2.1.</span> Uploading Another Creator's Content: Users are not allowed
                      to post content created by others (either on the Splendid App or posted on any
                      other social media platform) without explicit permission. This encompasses
                      videos, images, audio, or any other content, whether modified or unaltered.
                    </li>
                    <li>
                      <span>7.2.2.</span> Unauthorized Use of Deepfake Technology: Creating and
                      uploading deepfake content using other creators' identities or likenesses
                      without their consent is strictly prohibited. This also extends to any
                      appearance-altering technology, including those animating faces.
                    </li>
                    <li>
                      <span>7.2.3.</span> Altering Content to Remove Creators' Attribution or
                      Watermarks: Users must not manipulate content to remove original creators'
                      identification or watermarks, including changing aspect ratios, zooming, or
                      any other form of alteration to make it look like new content.
                    </li>
                    <li>
                      <span>7.2.4.</span> Posting Content from Creators Outside India Without
                      Acknowledgment: Sharing content from creators located outside India without
                      explicit permission or acknowledgement is against our guidelines and is
                      strictly prohibited.
                    </li>
                    <li>
                      <span>7.2.5.</span> Misleading Edits or Cropping: Editing videos to remove
                      intended elements by the original creator, such as likes, or cropping content
                      to conceal watermarks or attributions, is not allowed.
                    </li>
                    <li>
                      <span>7.2.6.</span> Unauthorized Use of Third-Party Intellectual Property
                      Rights: Utilizing third-party intellectual property rights without permission,
                      leading to infringement, is prohibited. Creators must obtain the necessary
                      permissions before using such content.
                    </li>
                  </ol>
                </li>
                <li>
                  <span>7.3.</span> If content shared on Splendid App or its platforms is found to
                  violate the platform's plagiarism guidelines or any other terms of use during
                  profile assessment, the following consequences will apply:
                  <ul style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      (i). Payment will not be made for any sales emanating from plagiarized or
                      infringing content.
                    </li>
                    <li>
                      (ii). The user will face immediate and permanent suspension from Splendid App
                      without prior notice.
                    </li>
                    <li>
                      (iii). No other commissions or earned rewards will be disbursed to the user.
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li>
              <b>8. AVAILIBILITY AND ACCESIBILITY OF THE PLATFORMS</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>8.1.</span> We control and operate the Platforms from India and make no
                  representation that the materials and the content available on the Platforms is
                  appropriate to be used or will be available for use in other locations outside
                  India. If you use the Platforms from outside India, you are entirely responsible
                  for compliance with all applicable local laws. These Terms of Use do not
                  constitute, nor may these Terms of Use be used for or in connection with any
                  promotional activities or solicitation by anyone in any jurisdiction in which such
                  promotional activities or solicitation are not authorized or to any person to whom
                  it is unlawful to promote or solicit.
                </li>
                <li>
                  <span>8.2.</span> We have several websites offering Products, Services, content
                  and various other functionalities to specific regions worldwide. The Services
                  offered in one region may differ from those in other regions due to availability,
                  local or regional laws, shipment and other considerations. We do not make any
                  warranty or representation that a user in one region may obtain the Services from
                  our site in another region and we may cancel a user's order or redirect a user to
                  the site for that user’s region if a user attempts to order Services offered on a
                  site in another region.
                </li>
                <li>
                  <span>8.3.</span> Information that we publish on the World Wide Web may contain
                  references or cross references to our Products, programs and Services that are not
                  announced or available in your country. Such references do not imply that we
                  intend to announce such Products, programs or Services in your country. Consult
                  our local business contact for information regarding the Products, programs and
                  Services that may be available to you.
                </li>
                <li>
                  <span>8.4.</span> We constantly monitor the user’s account in order to avoid
                  fraudulent accounts and transactions. Users with more than one account or availing
                  referral vouchers fraudulently shall be liable for legal actions under law and we
                  reserve the right to recover the cost of goods, collection charges and lawyer fees
                  from persons using the Platforms fraudulently. We reserve the right to initiate
                  legal proceedings against such persons for fraudulent use of the Platforms and any
                  other unlawful acts or omissions in breach of these terms and conditions. In the
                  event of detection of any fraudulent or declined transaction, prior to initiation
                  of legal actions, we reserve the right to immediately delete such account and
                  dishonour all past and pending orders without any liability. For the purpose of
                  this clause, we shall owe no liability for any refunds.
                </li>
              </ol>
            </li>
            <li>
              <b>9. THIRD PARTY INTERACTION AND LINKS TO THIRD PARTY SITES</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>9.1.</span> In your use of the Platforms, you may enter into correspondence
                  with, purchase goods and/or services from, or participate in promotions of
                  advertisers or members or sponsors or Merchants or Influencers of the Platforms or
                  access any other third-party website linked to the Platforms. Unless otherwise
                  stated, any such correspondence, advertisement, purchase or promotion, including
                  the delivery of and the payment for goods and/or services, and any other term,
                  condition, warranty or representation associated with such correspondence,
                  purchase or promotion, is solely between you and the applicable third party. You
                  agree that we have no liability, obligation or responsibility for any such
                  correspondence, purchase or promotion, access or usage of any third-party website
                  and the contract under such instances remains between you and any such third
                  party.
                </li>
              </ol>
            </li>
            <li>
              <b>10. COPYRIGHTS IN SPLENDID APP CONTENT</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>10.1.</span> The Platforms contain material, including text, graphics and
                  sound, which is protected by copyright and/or other intellectual property rights
                  (“Splendid App Content”). All copyright and other intellectual property rights in
                  the Splendid App Content are either owned by us or have been licensed to us by the
                  owner(s) of those rights so that it can use the Splendid App Content as part of
                  the Platforms. We retain copyright on all Information, including text, graphics
                  and sound and all trademarks displayed on the Platforms are either owned by or
                  licensed to us.
                </li>
                <li>
                  <span>10.2.</span> You may use and display the Splendid App Content on your
                  personal computer only for your personal use subject to the grant of a limited,
                  revocable, personal, non-exclusive and non-transferable license to you by us when
                  you register on any of the Platforms, only for identifying Products, carrying out
                  purchases of Products and processing returns and refunds in accordance with our
                  Return and Refund Policy and for using and printing copies of the information on
                  the Platforms for your personal use and store the files on your computer for
                  personal use only and not for business purposes.
                </li>
                <li>
                  <span>10.3.</span> You may not:
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      (a). Copy (whether by printing off onto paper, storing on disk, downloading or
                      in any other way), distribute (including distributing copies), download,
                      display, perform, reproduce, distribute, modify, edit, alter, enhance,
                      broadcast or tamper within any way or otherwise use any Splendid App Content
                      contained on the Platforms. These restrictions apply in relation to all or
                      part of the Splendid App Content available on the Platforms;
                    </li>
                    <li>
                      (b). Copy and distribute the Information on any other server, or modify or re-
                      use text or graphics on this system or another system;
                    </li>
                    <li>
                      (c). Reproduce any part of the Platforms or sell or distribute the same for
                      commercial gain nor shall it be modified or incorporated in any other work,
                      publication or web site, whether in hard copy or electronic format, including
                      postings to any other web site;
                    </li>
                    <li>
                      (d). Remove any copyright, trademark or other intellectual property notices
                      contained in the original material from any material copied or printed off
                      from the Platforms; or
                    </li>
                    <li>
                      (e). Link any other material to the Platforms, without our express written
                      consent.
                    </li>
                  </ol>
                </li>
                <li>
                  <span>10.4.</span> The license granted to you does not include a license for:
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      (a). Resale of Products or commercial use of the Platforms or Splendid App
                      Content.
                    </li>
                    <li>
                      (b). Any collection and use of product listings, description, or prices.
                    </li>
                    <li>
                      (c). Any use of the Platforms, the Services, and/or of Splendid App Content
                      other than as contemplated in these Terms of Use.
                    </li>
                    <li>(d). Any downloading or copying of login credentials of user.</li>
                    <li>
                      (e). Any use of data mining, robots, or similar data gathering and extraction
                      tools to extract (whether once or many times) any parts of the Platforms, and
                    </li>
                    <li>
                      (f). Creating and/ or publishing your own database that features parts of the
                      Platforms.
                    </li>
                  </ol>
                </li>
                <li>
                  <span>10.5.</span> If you believe that your intellectual property rights have been
                  used in a way that raises concerns of infringement, please write to us at{" "}
                  <a href="mailto:hello@splendid.app">hello@splendid.app</a> and let us know of your
                  concerns.
                </li>
              </ol>
            </li>
            <li>
              <b>11. TRADEMARKS</b>
              <p>
                All the trade names associated with us and all Products and logos denoted with TM
                are trademarks or registered trademarks of us or our affiliates. Our trademarks may
                not be used in connection with any product or service that is not our product or
                service.
              </p>
            </li>
            <li>
              <b>12. LICENSE AND USE OF YOUR CONTENT </b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>12.1.</span>
                  You grant to us a royalty-free, perpetual, irrevocable, non-exclusive right and
                  license to adopt, publish, reproduce, disseminate, transmit, distribute, copy,
                  use, create derivative works from, display worldwide, or act on any material
                  posted by you on the Platforms without additional approval or consideration in any
                  form, media, or technology now known or later developed, for the full term of any
                  rights that may exist in such content, and you waive any claim over all feedback,
                  comments, ideas or suggestions or any other content provided through or on the
                  Platforms. You agree to perform all further acts necessary to perfect any of the
                  above rights granted by you to us, including the execution of deeds and documents,
                  at its request.
                </li>
                <li>
                  <span>12.2.</span>
                  You agree that we do not routinely monitor your postings on the Platforms but
                  reserve the right to do so. However, if we become aware of inappropriate use of
                  the Platforms or any of its Services, we will respond in any way that, in its sole
                  discretion, we deem appropriate. You acknowledge that we will have the right to
                  report to law enforcement authorities of any actions that may be considered
                  illegal, as well as any information it receives of such illegal conduct. When
                  requested, we will co-operate fully with law enforcement agencies in any
                  investigation of alleged illegal activity on the internet.
                </li>
                <li>
                  <span>12.3.</span>
                  Submissions and unauthorised use of any materials contained on the Platforms may
                  violate copyright laws, trademark laws, the laws of privacy and publicity, certain
                  communications statutes and regulations and other applicable laws and regulations.
                  You alone are responsible for your actions or the actions of any person using your
                  username and/or password. As such, you shall indemnify and hold us and our
                  officers, directors, employees, affiliates, agents, licensors, and business
                  partners harmless from and against any and all loss, costs, damages, liabilities,
                  and expenses (including attorneys' fees) incurred in relation to, arising from, or
                  for the purpose of avoiding, any claim or demand from a third party that your use
                  of the Platforms or the use of the Platforms by any person using your user name
                  and/or password (including without limitation your participation in the posting
                  areas or your Submissions) violates any applicable law or regulation, or the
                  rights of any third party.
                </li>
                <li>
                  <span>12.4.</span>
                  We reserve the right to terminate access to the Platforms at any time and without
                  notice. Further this limited license terminates automatically, without notice to
                  you, if you breach any of these Terms of Use. Upon termination, you must
                  immediately destroy any downloaded and printed materials. Any provision of the
                  Terms of Use which imposes an obligation or creates a right that by its nature
                  will be valid after termination or expiration of the Terms of Use shall survive
                  the termination or expiration of the Terms of Use.
                </li>
              </ol>
            </li>
            <li>
              <b>13. USER WARRANTIES AND RESTRICTIONS</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>13.1.</span>
                  You represent and warrant that: (a) your use of the Platforms and/or Services will
                  not violate any applicable law or regulation; (b) all information that is
                  submitted to us in connection with the Platforms and/or Services is true, accurate
                  and lawful; (c) use of the content and material you supply does not breach any
                  applicable Agreement and will not cause injury to any person or entity (including
                  that the content or material is not defamatory). If at any time, the information
                  provided by you is found to be false or inaccurate, we will have the right to
                  reject registration, cancel all orders, and restrict you from using the Services
                  and other affiliated services in the future without any prior intimation
                  whatsoever. You agree to indemnify us and our affiliates for all claims brought by
                  a third party against it or its affiliates arising out of or in connection with a
                  breach of any of these warranties.
                </li>
                <li>
                  <span>13.2.</span>
                  You will use the Platforms for lawful purposes only and will not undertake any
                  activity that is harmful to the Platforms or its content or otherwise not
                  envisaged through the Platforms. You have a limited license to access and use the
                  Platforms solely for the purpose of availing the Services, subject to these Terms
                  of Use.
                </li>
                <li>
                  <span>13.3.</span>
                  You will not do any of the following:
                </li>
                <li>
                  <span>13.4.</span>
                  Delete or modify any content on the Platforms, including but not limited to any
                  information regarding the Services, their performance, sales or pricing, legal
                  notices, disclaimers or proprietary notices such as copyright or trademark
                  symbols, logos, that you do not own or have express permission to modify;
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      <span>13.4.1.</span>
                      Decompile, reverse engineer, or disassemble the content on the Platforms;
                    </li>
                    <li>
                      <span>13.4.2.</span>
                      Use the Services in any way that is unlawful, or harms Splendid App or any
                      other person or entity, as determined in Splendid App’s sole discretion;
                    </li>
                    <li>
                      <span>13.4.3.</span>
                      Use any engine, software, tool, agent or other mechanism (such as spiders,
                      robots, avatars, worms, time bombs, Easter eggs, cancel bots, intelligent
                      agents, etc.) to navigate or search the Platforms;
                    </li>
                    <li>
                      <span>13.4.4.</span>
                      Make false or malicious statements against the Services, the Platforms or us;
                    </li>
                    <li>
                      <span>13.4.5.</span>
                      Post, copy, submit, upload, distribute, or otherwise transmit or make
                      available any software or other computer files that contain a virus or other
                      harmful component, or otherwise disrupt or damage the Platforms and/or
                      Services or any connected network, or otherwise interfere with any person or
                      entity’s use or enjoyment of the Platforms and/or the Services;
                    </li>
                    <li>
                      <span>13.4.6.</span>
                      Introduce any Trojans, viruses, any other malicious software, any bots or
                      scrape the Platforms for any information
                    </li>
                    <li>
                      <span>13.4.7.</span>
                      Probe, scan, or test the vulnerability of any system, security or
                      authentication measures implemented by us or otherwise tamper or attempt to
                      tamper with our technological design and architecture;
                    </li>
                    <li>
                      <span>13.4.8.</span>
                      Hack into or introduce malicious software of any kind onto the Platforms;
                    </li>
                    <li>
                      <span>13.4.9.</span>
                      Gain unauthorized access to, or interfere with, or damage, or disrupt the
                      server on which the details connected to the Services are stored, or any other
                      server, computer, or database connected to the Services; or
                    </li>

                    <li>
                      <span>13.4.10.</span>
                      Engage in any form of antisocial, disruptive, or destructive acts, including
                      “flaming,” “spamming,” “flooding,” “trolling,”, “phishing” and “griefing” as
                      those terms are commonly understood and used on the internet
                    </li>
                    <li>
                      <span>13.4.11.</span>
                      You are prohibited from hosting, displaying, uploading, modifying, publishing,
                      transmitting, updating or sharing on or through the Platforms, any information
                      that:
                    </li>
                    <li>
                      <span>13.4.12.</span>
                      Is libellous, defamatory, abusive, threatening, harassing, hateful, and
                      offensive or otherwise violates any law or right of any third-party;
                    </li>
                    <li>
                      <span>13.4.13.</span>
                      Belongs to another person and to which you do not have any right;
                    </li>
                    <li>
                      <span>13.4.14.</span>
                      Is harmful, harassing, blasphemous, defamatory, obscene, pornographic,
                      paedophilic, invasive of another’s privacy, hateful, relating to or
                      encouraging money laundering or gambling, or otherwise harmful in any manner
                      whatsoever;
                    </li>
                    <li>
                      <span>13.4.15.</span>
                      Harms minors in any way;
                    </li>
                    <li>
                      <span>13.4.16.</span>
                      Infringes any patent, trademark, copyright or other proprietary rights;
                    </li>
                    <li>
                      <span>13.4.17.</span>
                      Violates any law for the time being in force
                    </li>
                    <li>
                      <span>13.4.18.</span>
                      Deceives or misleads the addressee about the origin of such messages or
                      communicates any information which is grossly offensive or menacing;
                    </li>
                    <li>
                      <span>13.4.19.</span>
                      Impersonates or defames another person; or
                    </li>
                    <li>
                      <span>13.4.20.</span>
                      Contains software viruses or any other computer code, files or programs
                      designed to interrupt, destroy or limit the functionality of any computer
                      resource.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <b>14. CONFIDENTIALITY</b>
              <p>
                In connection with the Services, the Parties may disclose or deliver, or cause to be
                disclosed or delivered, to each other Confidential Information (as defined below).
              </p>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>14.1</span> The term “Confidential Information” shall mean all trade secrets
                  or confidential or proprietary information or business strategies disclosed (or
                  caused to be disclosed) by or on behalf of the disclosing Party to the receiving
                  Party, as applicable, in any form whatsoever, including confidential or
                  proprietary information relating to or acquired from:
                  <ul style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>(i). The disclosing Party;</li>
                    <li>
                      (ii). Any sponsors of, investors in, or lenders to, the disclosing Party;
                    </li>
                    <li>
                      (iii). Any other contract counterparties or business relationships of the
                      disclosing Party.
                    </li>
                  </ul>
                  Confidential Information shall include:
                  <ul style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      (i). All information pertaining to the disclosing Party’s operations,
                      administration, the directors, officers, employees, contractors, agents,
                      representatives or advisors (including attorneys, accountants, consultants,
                      bankers and financial advisors) of the disclosing Party;
                    </li>
                    <li>
                      (ii). Methods for arranging a value chain, distributing a product or
                      distributing revenues, collectively;
                    </li>
                    <li>
                      (iii). The status, subject matter or scope of any intellectual property
                      applications relating to the Confidential Information;
                    </li>
                    <li>
                      (iv). Any financial information, information relating to any off-takers or
                      vendors or an investor relating to the disclosing Party; and
                    </li>
                    <li>
                      (v). Information identical or similar in nature to the aforesaid information.
                    </li>
                  </ul>
                </li>

                <li>
                  <span>14.2.</span>
                  Use and Disclosure of Confidential Information The receiving Party shall hold the
                  Confidential Information in strict confidence and will not disclose, copy,
                  reproduce or distribute any of it to any person other than as directed by court or
                  any government or regulatory authority or as permitted in writing by the
                  disclosing Party or, subject to as provided below and in clause above to its
                  Representatives (as defined below). The receiving Party shall (and shall procure,
                  in so far as it is legally able to do so, that each of its Representatives shall)
                  use the Confidential Information, only for the purpose of providing Services, and
                  that the Confidential Information shall not be used for any other purpose without
                  the disclosing Party’s prior written consent. The receiving Party shall disclose
                  Confidential Information disclosed to it under the Agreement only to those members
                  and affiliates of the receiving Party including the directors, officers,
                  employees, agents, representatives or advisors, including attorneys, accountants,
                  consultants, bankers, financial advisors and members of advisory boards of the
                  receiving Party (collectively, “Representatives”) who have a strict need to know
                  such Confidential Information in the course of the performance of their duties in
                  connection with the Services. Prior to the disclosure of any Confidential
                  Information to any of its Representatives, the receiving Party shall take
                  reasonable care to inform such Representatives of the confidentiality of such
                  Confidential Information and the terms as provided herein and shall require such
                  Representative to keep such Confidential Information in accordance with the terms
                  of this Agreement.
                </li>

                <li>
                  <span>14.3.</span>
                  Ownership of Confidential Information The Receiving Party agrees that it shall not
                  and its Representatives shall not receive any right, title or interest in, or any
                  license or right to use (other than for the Proposed Transaction), the
                  Confidential Information or any intellectual property rights therein, by
                  implication or otherwise.
                </li>

                <li>
                  <span>14.4. </span>
                  Return of Confidential Information Upon the termination of this Agreement for
                  whatever reason, the disclosing Party may, within 10 days of such termination,
                  submit a written request to the receiving Party (which the receiving Party agrees
                  to comply with within 10 days of such written request), to return to the
                  disclosing Party or destroy all Confidential Information received by the receiving
                  Party and/or its Representatives (and all copies and reproductions thereof) and
                  any notes, reports or other documents prepared by the receiving Party and/or its
                  Representatives which contain Confidential Information provided that, subject to
                  the confidentiality obligations herein, the receiving Party and its
                  Representatives
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      (a). may retain Confidential Information and any notes, reports or other
                      documents containing Confidential Information (or copies thereof) for the
                      purposes of and so long as required by any relevant law, governmental or
                      regulatory authority, or internal audit requirements;
                    </li>
                    <li>
                      (b). may retain copies of any computer records or files containing
                      Confidential Information which have been created pursuant to the receiving
                      Party or its Representatives’ automatic and back-up procedures; and
                    </li>
                    <li>
                      (c). may retain Confidential Information or copies thereof contained or
                      referred to in board papers, minutes or resolutions, investment committee
                      papers or in documents referred to in any of the aforementioned documents.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <b>15. INDEMNIFICATION AND LIMITATION OF LIABILITY</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>15.1. </span> You agree to indemnify, defend and hold harmless us, our
                  affiliates, officers, directors, employees, consultants, licensors, agents, and
                  representatives from and against any and all third- party claims, losses,
                  liabilities, damages, and/or costs (including reasonable attorney fees and costs)
                  arising from your access to or use of the Platforms or the Services, violation of
                  these Terms of Use, or infringement of any of our or any third- party intellectual
                  property or other rights. We will notify you promptly of any such claim, loss,
                  liability, or demand, and in addition to the foregoing, you agree to provide us
                  with reasonable assistance, at your expense, in defending any such claim, loss,
                  liability, damage, or cost.
                </li>
                <li>
                  <span>15.2. </span> To the fullest extent permitted by law, in no event shall
                  Splendid App or any of its directors, officers, employees, agents or content or
                  service providers (collectively, the “Splendid App Representatives”) be liable to
                  you for any direct, indirect, special, incidental, consequential, exemplary,
                  special, remote or punitive damage, including, but not limited to damages for loss
                  of profits, goodwill, use, data or other intangible losses arising from, or
                  directly or indirectly related to, the use of, or the inability to use, the
                  Platforms or the content, materials and functions related thereto, the Services,
                  provision of information via the Platforms, lost business, even if such Splendid
                  App Representatives have been advised of the possibility of such damages.
                </li>
                <li>
                  <span>15.3. </span> In no event shall Splendid App Representatives be liable for:
                  <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                    <li>
                      <span>15.3.1 </span>
                      The use or inability to use the Platforms and/or the Services;
                    </li>
                    <li>
                      <span>15.3.2 </span>
                      Any content posted, transmitted, exchanged or received by or on behalf of any
                      user or other person on or through the Platforms; or
                    </li>
                    <li>
                      <span>15.3.3 </span>
                      Any other matter relating to the Platforms or the Services.
                    </li>
                  </ol>
                </li>
                <li>
                  <span>15.4. </span> Splendid App is neither liable nor responsible for any actions
                  or inactions of the other users of the Platforms or any breach of conditions,
                  representations or warranties by them. Splendid App is not obligated to mediate or
                  resolve any dispute or disagreement amongst two or more users of the Platforms.
                </li>
                <li>
                  <span>15.5. </span> None of the directors, officials or employees of Splendid App
                  shall be personally liable for any action in connection with the Platforms or the
                  Services thereto.{" "}
                </li>
              </ol>
            </li>
            <li>
              <b>16. ACCESS OUTSIDE THE REPUBLIC OF INDIA </b>
              <p>
                Splendid App makes no representation that the content on the Platforms is
                appropriate to be used or accessed outside the Republic of India. Your use of or
                access to the Platforms from outside the Republic of India is at your own risk and
                you are responsible for compliance with the laws of such jurisdiction.
              </p>
            </li>
            <li>
              <b>17. APPLICABLE LAW AND JURISDICTION:</b>
              <p>
                These Terms of Use are governed by and to be interpreted in accordance with laws of
                India, without regard to the choice or conflicts of law provisions of any
                jurisdiction. You agree, in the event of any dispute arising in relation to these
                Terms of Use or any dispute arising in relation to the Platforms, whether in
                contract or tort or otherwise, to submit to the jurisdiction of the courts located
                at Mumbai, India for the resolution of all such disputes.{" "}
              </p>
            </li>
            <li>
              <b>18. GRIEVANCE OFFICER:</b>
              <p>
                In accordance with the applicable law, any grievances which you may have with
                respect to the information shared by you with us hereunder and its treatment or any
                grievance related to Services being availed hereunder may be directed by you to{" "}
                <a href="mailto:hello@splendid.app">hello@splendid.app</a>
              </p>
            </li>
            <li>
              <b>19. FORCE MAJEURE</b>
              <p>
                We will not be held responsible for any delay or failure to comply with its
                obligations if the delay or failure arises from any because which is beyond our
                reasonable control.{" "}
              </p>
            </li>
            <li>
              <b>20. WAIVER</b>
              <p>
                No provision in these Terms of Use will be deemed waived and no breach excused,
                unless such waiver or consent is in writing and signed by us. Any consent by us to,
                or waiver of your breach, whether expressed or implied, will not constitute consent
                to, waiver of, or excuse for any other different or subsequent breach.
              </p>
            </li>
            <li>
              <b>21. SEVERABILITY</b>
              <p>
                If any provision of these Terms of Use is held by a court of competent jurisdiction
                to be unenforceable under applicable law, then such provision will be excluded from
                these Terms of Use and the remainder of these Terms of Use will be interpreted as if
                such provision were so excluded and will be enforceable in accordance with its
                terms; provided however that, in such event, these Terms of Use will be interpreted
                so as to give effect, to the greatest extent consistent with and permitted by
                applicable law, to the meaning and intention of the excluded provision as determined
                by such court of competent jurisdiction.
              </p>
            </li>
            <li>
              <b>22. AMENDMENT</b>
              <p>
                These Terms of Use are subject to amendments and modifications and may be updated
                from time to time, without any advance notice. You are requested to regularly review
                the Terms of Use as available on the Platforms. You relationship with the Platforms
                will be governed by the most current version of these Terms of Use, as published on
                the Platforms.{" "}
              </p>
            </li>
            <li>
              <b>23. MISCELLANEOUS</b>
              <ol style={{ listStyleType: "none", paddingLeft: "20px" }}>
                <li>
                  <span>23.1. </span>
                  In addition to these Terms of Use, you will also ensure that you comply with the
                  terms and conditions of the third parties, such as bank offers terms and
                  conditions, and brand promotional offers, whose links, if any, are
                  contained/embedded in the Services. You agree that we will not be liable for any
                  transaction between itself and any such third parties.
                </li>
                <li>
                  <span>23.2. </span>
                  These Terms of Use supersede all previous oral and written terms and conditions
                  (if any) communicated to you by us, for the use of the Platforms, and the rights
                  and liabilities with respect to any Services to be provided by us shall be limited
                  to the scope of these Terms of Use.
                </li>
              </ol>
            </li>
            <li>
              <b>Escalation Desk </b>
              <p>
                Splendid App Private Limited, <br />
                Address: 235, Binnamangala, 2nd Floor 13th Cross Road, 2nd Stage Indiranagar
                (Bangalore) <br />
                Bangalore North Bangalore KA 560038 IN. <br />
                Contact us: <a href="mailto:hello@splendid.app">hello@splendid.app</a> <br />
                Time: Mon – Fri (11:00 – 18:00){" "}
              </p>
            </li>
          </ol>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;
